import { render } from "./network-detail.vue?vue&type=template&id=08e960c8&scoped=true&ts=true"
import script from "./network-detail.vue?vue&type=script&lang=ts"
export * from "./network-detail.vue?vue&type=script&lang=ts"

import "./network-detail.vue?vue&type=style&index=0&id=08e960c8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e960c8"]])

export default __exports__